import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Autocomplete from 'react-autocomplete'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

import {dateFormat} from '../../thesis-and-dissertations/helpers/helper'

const FormGenerator = (
  data: any[],
  formsValue: any,
  onChange: any,
  onSelect?: any,
  isLoading = false
) => {
  const [rich, setRich] = useState<any>('')
  return data?.map((input: any, key: any) => {
    if (input.type === 'autocomplete') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <br />
            <Autocomplete
              wrapperStyle={{
                width: '100%',
              }}
              getItemValue={(item) => item[input.getItemValue]}
              items={input.items || []}
              renderInput={(props: any) => <Form.Control name={input.name} {...props} />}
              renderItem={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? 'lightgray' : 'white',
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 10,
                  }}
                  key={Math.random()}
                >
                  {item[input.getItemValue]}
                </div>
              )}
              value={formsValue[input.name]}
              onChange={onChange}
              onSelect={(val, row) => {
                onChange({
                  target: {
                    name: input.name,
                    value: row[input.getItemValue],
                  },
                })
                onSelect(input.name, row, key)
              }}
            />
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'textarea') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <Form.Control
              name={input.name}
              as='textarea'
              rows={input.row ?? 3}
              value={formsValue[input.name]}
              onChange={onChange}
              disabled={input.disabled || isLoading}
            />
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'select') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <Form.Select
              aria-label={input.label}
              disabled={input.disabled || isLoading}
              onChange={onChange}
              name={input.name}
              value={formsValue[input.name]}
            >
              {input.options?.map((item2: any) => {
                return (
                  <option
                    value={item2[input.getItemValueId]}
                    key={Math.random()}
                    selected={item2[input.getItemValueId] === formsValue[input.name]}
                  >
                    {item2[input.getItemValue]}
                  </option>
                )
              })}
            </Form.Select>
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'radio') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <br />
            <br />
            {input.options?.map((item2: any, key2: any) => {
              return (
                <Form.Check
                  label={item2[input.getItemValue]}
                  inline
                  name={input.name}
                  className={input.mb || 'mb-6'}
                  type={input.type}
                  id={input.name}
                  key={key2 + input.name}
                  value={item2[input.getItemValueId]}
                  onChange={(row) => {
                    onChange({
                      target: {
                        name: input.name,
                        value: row.target.value,
                      },
                    })
                  }}
                />
              )
            })}
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'checkbox') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <br />
            <br />
            {input.options?.map((item2: any, key2: any) => {
              return (
                <Form.Check
                  label={item2[input.getItemValue]}
                  inline
                  name={input.name}
                  className={input.mb || 'mb-6'}
                  type={input.type}
                  id={input.name}
                  key={key2 + input.name}
                  value={item2[input.getItemValueId]}
                />
              )
            })}
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'select2') {
      let selectedDefault = input.options?.filter(
        (option: {[x: string]: any}) => option[input.getItemValueId] == formsValue[input.name]
      )
      let defaultValue =
        typeof formsValue[input.name] === 'object' ? formsValue[input.name] : selectedDefault
      let selectedValue = input.options?.filter(
        (option: {[x: string]: any}) => option[input.getItemValue] === formsValue[input.name]
      )
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <Select
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
              })}
              isMulti={input.isMulti}
              name={input.name}
              options={input.options}
              value={selectedValue?.length > 0 ? selectedValue : defaultValue}
              className='basic-multi-select'
              classNamePrefix='select'
              placeholder={`Pilih ${input.label}`}
              getOptionLabel={(opt: any) => opt[input.getItemValue]}
              getOptionValue={(opt: any) => opt[input.getItemValueId]}
              onChange={(row) => {
                onChange({
                  target: {
                    name: input.name,
                    value: row,
                  },
                })
              }}
              onInputChange={(row) => {
                if (typeof onSelect === 'function') {
                  onSelect(input.name, row, key)
                }
              }}
              isDisabled={input.disabled}
              isLoading={isLoading}
            />
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'rich-text') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <ReactQuill
              theme='snow'
              value={formsValue[input.name]}
              // onChange={setRich}
              onChange={(row) => {
                setRich(row)
                onChange({
                  target: {
                    name: input.name,
                    value: row,
                  },
                })
              }}
              readOnly={input.disabled || isLoading}
            />
            <input type='hidden' name={input.name} value={formsValue[input.name]} />
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'select-creatable') {
      let options: {value: any; label: any}[] = []
      if (input.options?.length > 0) {
        input.options.map((item: any) => {
          options.push({
            value: item[input.getItemValue],
            label: item[input.getItemValue],
          })
        })
      }

      let defaultObjectValue = {label: formsValue[input.name], value: formsValue[input.name]}
      let defaultValue =
        typeof formsValue[input.name] === 'object' ? formsValue[input.name] : defaultObjectValue
      let selectedValue = options.filter((option) => option.value === formsValue[input.name])
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <CreatableSelect
              isClearable
              isMulti={input.isMulti}
              placeholder={`Pilih ${input.label}`}
              name={input.name}
              value={selectedValue?.length > 0 ? selectedValue : defaultValue}
              options={options}
              onChange={(row) => {
                onChange({
                  target: {
                    name: input.name,
                    value: row,
                  },
                })
              }}
              onInputChange={(row) => {
                onSelect(input.name, row, key)
              }}
              isLoading={isLoading}
              isDisabled={input.disabled}
            />
          </Form.Group>
        </Col>
      )
    } else if (input.type === 'file') {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <Form.Control
              type="file"
              name={input.name}
              onChange={(e) => {
                const target = e.target as HTMLInputElement
                const file = target.files?.[0]
                
                // Create a FormData object to properly handle file uploads
                if (file) {
                  onChange({
                    target: {
                      name: input.name,
                      value: file,
                      files: target.files
                    },
                  })
                }
              }}
              disabled={input.disabled || isLoading}
              accept={input.accept || '*'}
              multiple={input.multiple || false}
            />
            {formsValue[input.name] && (
              <div className="mt-2">
                <small className="text-muted">
                  File terpilih: {formsValue[input.name]?.name || formsValue[input.name]}
                </small>
              </div>
            )}
            <span style={{position: 'absolute', marginTop: '-4%', right: '10%', ...input.style}}>
              {input.additional}
            </span>
          </Form.Group>
        </Col>
      )
    } else {
      return (
        <Col md={input.col} key={key}>
          <Form.Group className={input.mb || 'mb-6'} controlId={`id-${input.name}`}>
            <Form.Label>{input.label}</Form.Label>
            <Form.Control
              type={input.type}
              name={input.name}
              value={
                input.type == 'date' ? dateFormat(formsValue[input.name]) : formsValue[input.name]
              }
              onChange={onChange}
              disabled={input.disabled || isLoading}
            />
            <span style={{position: 'absolute', marginTop: '-4%', right: '10%', ...input.style}}>
              {input.additional}
            </span>
          </Form.Group>
          {input.child?.map((itemChild: any, keyChild: any) => (
            <Form.Check
              type='checkbox'
              label={itemChild.label}
              disabled={itemChild.disabled}
              name={itemChild.name}
              onChange={onChange}
              key={key + '-' + keyChild}
              checked={input.disabled}
            />
          ))}
        </Col>
      )
    }
  })
}

export default FormGenerator
